import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center mb-4" }
const _hoisted_2 = ["src", "height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    style: {"height":"100vh"},
    class: "d-flex align-center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "d-flex align-center justify-center fill-height",
        style: {"height":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "10",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("img", {
                    src: _ctx.Bobbee,
                    height: !_ctx.$vuetify.display.mobile ? '100vh' : '',
                    width: !_ctx.$vuetify.display.mobile ? '' : '200vw'
                  }, null, 8, _hoisted_2)
                ]),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-center display-2"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" Erreur 404: Page non trouvée ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}